<template>
  <v-menu
    v-model="filterMenu"
    bottom
    left
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        dark
        icon
        v-bind="attrs"
        v-on="on"
        @click="handleClick(filterKey)"
      >
        <v-icon>mdi-filter-variant</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        class="pr-2"
        style="border-bottom:1px solid #c8dcf0"
      >
        <v-list-item-title class="d-flex justify-space-between">
          <span class="pr-5 success--text">
            {{ title }}
          </span>
          <v-icon
            class="pr-2 success--text"
            @click="filterMenu = false"
            size="18"
          >
            close
          </v-icon>
        </v-list-item-title>
      </v-list-item>
      <template v-if="appFilters.length > 0">
        <v-list-item
          v-for="(item, i) in appFilters"
          :key="i"
          class="my-2"
        >
          <v-list-item-title style="font-size:14px;">
            <div class="d-flex">
              <span
                v-if="schoolLogo(item.id) != 'my-nsw-gov'"
                class="pr-2"
              >
                <div
                  class="school-logo"
                  :style="`border-color: ${getSchoolColour(item.id)}`"
                >
                  <v-img
                    :src="schoolLogo(item.id)"
                    height="18px"
                    width="18px"
                  />
                </div>
              </span>
              <span
                v-else
                class="pr-2"
              >
                <div
                  class="school-logo"
                  :style="`border-color: ${getSchoolColour(item.id)}`"
                >
                  <v-img
                    src="/NSWGov_Logo.png"
                    height="18px"
                    width="18px"
                  />
                </div>
              </span>
              <span class="d-flex align-center">
                {{ schoolName(item.id) }}
              </span>
            </div>
          </v-list-item-title>
          <v-list-item-action class="pr-2">
            <v-switch v-model="item.value" />
          </v-list-item-action>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>
<script>
import { AppIcon } from "@nswdoe/doe-ui-core";
import features from "@/features.json";
import {
  FA_SCREEN_CLASS,
  FA_SCREEN_NAME,
  FA_SCREEN_VIEW
} from "@/settings/constants";
const AppBarFilters = {
  name: "AppBarFilter",
  components: {
    AppIcon
  },
  props: {
    mySchools: {
      type: Array,
      default: function() {
        return [];
      }
    },
    appFilters: {
      type: Array,
      default: function() {
        return [];
      }
    },
    title: String,
    filterKey: String
  },
  methods: {
    schoolName(id) {
      if (id != "global") {
        return this.mySchools.find(school => school.schoolId == id)?.details
          .name;
      }

      return "NSW Department of Education";
    },
    schoolLogo(id) {
      if (id != "global") {
        return this.mySchools.find(school => school.schoolId == id)?.details
          .logo;
      }

      return "my-nsw-gov";
    },
    getSchoolColour(schoolId) {
      if (schoolId != "global") {
        return this.mySchools.find(
          schoolInfo => schoolInfo.schoolId == schoolId
        )?.details.colour;
      }
      return "#264189";
    },
    handleClick(filterKey) {
      if (
        !this.filterMenu &&
        parseInt(this.getCookie("appbuild")) >= features.analytics
      ) {
        let screenClass = undefined;
        switch (filterKey) {
          case "newsFilter":
            screenClass = "news";
            break;
          case "eventFilter":
            screenClass = "calendar";
            break;
          case "newsletterFilter":
            screenClass = "newsletters";
            break;
        }

        if (screenClass) {
          this.analytics(FA_SCREEN_VIEW, {
            [FA_SCREEN_CLASS]: screenClass,
            [FA_SCREEN_NAME]: "school_filter"
          });
        }
      }
    }
  },
  data() {
    return {
      filter: this.appFilters.map(school => {
        return {
          id: school.id,
          value: school.value
        };
      }),
      filterMenu: false
    };
  },
  watch: {
    title() {
      this.filter = this.mySchools.map((school, i) => {
        let schoolId = school.schoolId;
        return {
          id: schoolId,
          value: this.appFilters[i] ? this.appFilters[i].value : false
        };
      });
      console.log("app Filter changes");
    }
  }
};
export default AppBarFilters;
</script>
<style lang="scss" scoped>
.school-logo {
  padding: 7px;
  border: 2px solid;
  border-radius: 100px;
}
</style>
